import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const usePageWrapperStyles = makeStyles((_theme) =>
  createStyles({
    pageWrapper: {
      display: 'flex',
      height: '100%',
      flexDirection: 'column',
    },
  })
);

export default usePageWrapperStyles;
